module.exports = __webpack_public_path__ + "static/media/cherry.6d7d4eb6.png";